//@flow

const CHANGE_LOGGED = "CHANGE_LOGGED"
const ADD_JRR = "ADD_JRR"
const REMOVE_JRR = "REMOVE_JRR"
const DROP_API = "DROP_API"
const INCREMENT_TCOUNT = "INCREMENT_TCOUNT"

export const changeLogged = value => {
  let action = {
    type: CHANGE_LOGGED,
    value,
  }
  return action
}

export const addJRR = value => {
  let action = {
    type: ADD_JRR,
    value,
  }
  return action
}

export const incrementTcount = () => {
  let action = {
    type: INCREMENT_TCOUNT,
  }
  return action
}

export const removeJRR = () => ({
  type: REMOVE_JRR,
})

export const dropApiData = () => ({
  type: DROP_API,
})
